import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { computed } from "mobx";
import { Breadcrumb, Button, Icon, Ref } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import User from "~/models/User";
import PageStore from "~/stores/PageStore";
import "../styles/PageIndexPage.less";
import LoadingWrapper from "~/components/wrapper/LoadingWrapper";
import RouteWrapper from "../../spa/component/wrapper/RouteWrapper";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import PageForm from "../components/PageForm";
import StickyMenu from "~/components/StickyMenu";
import ToastMessageStore from "~/stores/ToastMessageStore";

@observer
class PageActionPage extends Component {
  ref = null;

  constructor(props) {
    super(props);
    const { isEdit } = this.props;
    this.ref = createRef();
    document.title = isEdit ? "Edit Page" : "Create Page";
    this.pageStore = new PageStore();
  }

  componentDidMount() {
    const { user, match, isEdit, isToursPage } = this.props;
    const { customer } = user;
    this.pageStore.customerId = customer.customerId;

    if (isEdit) {
      this.pageStore.pageId = isToursPage ? "tours" : parseInt(match.params.pageId, 10);
      this.pageStore
        .loadOne()
        .then()
        .catch(error => error.message);
    } else {
      this.pageStore.reset();
      this.pageStore.page.customerId = this.pageStore.customerId;
    }
  }

  onChange(e) {
    const { name, value } = e.target;
    this.pageStore.page[name] = value;
  }

  onChangeCheckbox(e, data) {
    this.pageStore.page.isActive = data.checked;
  }

  onChangeSlug(e) {
    const { value } = e.target;
    let str = value;
    str = str.replace(/\s+/g, "-").toLowerCase();
    this.pageStore.page.slug = str;
  }

  onSubmit() {
    const { redirectTo, showError, isEdit, isToursPage, toastMessageStore, t } = this.props;
    const { page, pageId } = this.pageStore;
    this.pageStore.errorMessages = {};
    this.pageStore.isSaved = false;

    const data = {};

    if (!isToursPage) {
      data.slug = page.slug;
      data.title = page.title;
      data.description = page.description;
      data.isActive = page.isActive;
    }

    if (page.photoData !== "") {
      data.photoData = page.photoData;
    }

    if (page.photoUrl === null) {
      data.photoUrl = page.photoUrl;
    }

    if (isEdit) {
      this.pageStore
        .update(pageId, data)
        .then(() => {
          toastMessageStore.addToastMessage(t("changesSaved"), "positive", t("success"));
          redirectTo("/profile/pages");
        })
        .catch(error => showError(error.message));
    } else {
      this.pageStore
        .create(data)
        .then(() => {
          toastMessageStore.addToastMessage(t("changesSaved"), "positive", t("success"));
          redirectTo("/profile/pages");
        })
        .catch(error => showError(error.message));
    }
  }

  @computed
  get breadcrumbsLabel() {
    const { isEdit, isToursPage, t } = this.props;
    const { page } = this.pageStore;

    if (!isEdit) {
      return t("customerPortal:newPage");
    }

    if (isToursPage) {
      return t("customerPortal:editMyToursPage");
    }

    return t("customerPortal:editPage", { pageId: page.pageId });
  }

  render() {
    const { isLoading } = this.pageStore;
    const { isEdit, t } = this.props;
    if (isLoading) {
      return <LoadingWrapper loading={isLoading} />;
    }

    return (
      <>
        <div className="page-index-outer-container">
          <Breadcrumb style={{ marginBottom: "2rem" }}>
            <Breadcrumb.Section>
              <Link to="/profile/pages">{t("customerPortal:myPages")}</Link>
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section active>{this.breadcrumbsLabel}</Breadcrumb.Section>
          </Breadcrumb>
          <Ref innerRef={this.ref}>
            <div>
              <StickyMenu
                contextRef={this.ref}
                headerText={this.breadcrumbsLabel}
                button={
                  <Button primary icon disabled={!this.pageStore.hasUnsavedData} onClick={() => this.onSubmit()}>
                    <Icon name="save" />
                    {isEdit ? t("messages:save") : t("customerPortal:create")}
                  </Button>
                }
              />

              <PageForm
                onChangeDescription={e => this.onChangeDescription(e)}
                onChange={e => this.onChange(e)}
                onChangeCheckbox={(e, data) => this.onChangeCheckbox(e, data)}
                onChangeSlug={e => this.onChangeSlug(e)}
                pageStore={this.pageStore}
                onSave={() => this.onSubmit()}
              />
            </div>
          </Ref>
        </div>
      </>
    );
  }
}

PageActionPage.propTypes = {
  isEdit: PropTypes.bool.isRequired,
  isToursPage: PropTypes.bool.isRequired,
  user: PropTypes.instanceOf(User).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      pageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }),
  t: PropTypes.func.isRequired,
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
};

export default withTranslation()(ErrorWrapper(RouteWrapper(PageActionPage)));
